export const LS_ENV_NAME = 'environment';

export const LS_FREIGHTER_ACCOUNT_CHANGE_IMMEDIATELY = 'freighter_account_change_immediately';
